// src/pages/BackendDevelopment.tsx
import styled from 'styled-components';

export default function BackendDevelopment() {
  return (
    <Container>
      <Title>Backend Development (.NET)</Title>
      <Subtitle>
        Building reliable, secure, and scalable server-side applications with .NET Core.
      </Subtitle>

      <Content>
        <Section>
          <h3>Core Concepts</h3>
          <ul>
            <li>Clean Architecture & SOLID principles</li>
            <li>RESTful API design</li>
            <li>Authentication & Authorization (JWT, OAuth)</li>
            <li>Database integration (SQL, MongoDB)</li>
          </ul>
        </Section>

        <Section>
          <h3>Tech Stack</h3>
          <TechGrid>
            <TechItem>.NET 8</TechItem>
            <TechItem>Entity Framework Core</TechItem>
            <TechItem>MongoDB Driver</TechItem>
            <TechItem>Azure</TechItem>
            <TechItem>Docker</TechItem>
          </TechGrid>
        </Section>

        <Section>
          <h3>Sample API Endpoint</h3>
          <CodeBlock>
            {`[HttpGet("{id}")]
public async Task<IActionResult> GetItem(int id)
{
    var item = await _service.GetByIdAsync(id);
    return item == null ? NotFound() : Ok(item);
}`}
          </CodeBlock>
        </Section>
      </Content>
    </Container>
  );
}

// Styled Components
const Container = styled.div`
  padding: 4rem 2rem;
  color: ${({ theme }) => theme.text};
`;

const Title = styled.h1`
  font-size: 2.8rem;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  margin-bottom: 3rem;
  color: ${({ theme }) => theme.text};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

const Section = styled.div`
  h3 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.primary};
  }
  ul {
    list-style: disc;
    padding-left: 1.5rem;
  }
`;

const CodeBlock = styled.pre`
  background: rgba(255, 255, 255, 0.08);
  padding: 1rem;
  border-radius: 0.5rem;
  font-family: monospace;
  white-space: pre-wrap;
`;

const TechGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 1rem;
`;

const TechItem = styled.div`
  background: rgba(255, 255, 255, 0.08);
  padding: 0.8rem;
  border-radius: 0.5rem;
  text-align: center;
  font-weight: bold;
  box-shadow: ${({ theme }) => theme.buttonShadow};
`;
